import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-i18next'
import ContentHeader from 'component/utils/ContentHeader'
import OccurrencesCode8 from 'component/report/occurrencescode8/OccurrencesCode8'

class OccurrencesCode8Container extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
  }

  render() {
    const { translate } = this.props

    return (
      <section>
        <ContentHeader>{translate('occurrences-code8.title')}</ContentHeader>

        <OccurrencesCode8 translate={translate} />
      </section>
    )
  }
}

/*
 * Connects component to I18next
 */
const OccurrencesCode8Translated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(OccurrencesCode8Container)

/*
 * Exports component connected to redux as default
 */
export default OccurrencesCode8Translated

/*
 * Exports as component
 */
export { OccurrencesCode8Container }
